<iframe
  [src]="urlSafe"
  name="myIframe"
  class="iframe"
  id="doku-iframe"
  [title]="title"
  sandbox=" allow-top-navigation allow-same-origin allow-downloads allow-scripts allow-popups allow-forms allow-pointer-lock"
></iframe>
